import { useStore } from 'vuex'

/**
 * 活动开关（仅用于后续新增活动）。
 * 存量功能不要包开关；新活动用 isActivityEnabled(code)，未在后台开启则不展示。
 *
 * @example
 * const { isActivityEnabled } = useActivityControl()
 * if (isActivityEnabled('new_promo')) { ... }
 */
export function useActivityControl() {
  const store = useStore()

  const isActivityEnabled = (code, defaultEnabled = false) =>
    store.getters['config/isActivityEnabled'](code, defaultEnabled)

  return { isActivityEnabled }
}

export function isActivityEnabled(store, code, defaultEnabled = false) {
  if (!store) return defaultEnabled
  return store.getters['config/isActivityEnabled'](code, defaultEnabled)
}
